import type { AnchorHTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/cn'

interface ExternalLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  children?: ReactNode
}

/**
 * Replacement for <a> in markdown rendering.
 * - Absolute URLs get target=_blank + rel=noopener noreferrer (security).
 * - Relative/hash URLs are left as plain anchors (in-page navigation).
 * - Focus ring uses the existing design token.
 */
export function ExternalLink({ href, children, className, ...props }: ExternalLinkProps) {
  const isAbsolute = href?.startsWith('http://') || href?.startsWith('https://')

  return (
    <a
      href={href}
      className={cn(
        'text-[color:var(--brand-primary,hsl(var(--primary)))] underline underline-offset-2 hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1 rounded-sm',
        className,
      )}
      {...(isAbsolute
        ? { target: '_blank', rel: 'noopener noreferrer' }
        : {})}
      {...props}
    >
      {children}
    </a>
  )
}
